<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="PROJECT BRIEF" >
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'project-brief-sheet'" />
              <vs-button v-can="'create-edit-project-brief'" @click="onClickCreateSite" class="mr-4" color="primary" type="filled">Create</vs-button>
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="customer-project-brief-list-table" v-can="'view-project-brief'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="20%" sort-key="project_brief_code">PROJECT BRIEF CODE</vs-th>
                <vs-th width="20%" sort-key="name">NAME</vs-th>
                <vs-th width="20%">FORMULATIONS</vs-th>
                <vs-th width="15%">ASSIGNED STAFF</vs-th>
                <vs-th  >STATUS</vs-th>
                <vs-th  v-can="'create-edit-project-brief'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickCustomerSiteUpdate(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].project_brief_code">
                    {{ data[indextr].project_brief_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name}}
                  </vs-td>

                  <vs-td :data="data[indextr].formulations">
                    <span v-if="data[indextr].formulations.length > 0" v-for="item in data[indextr].formulations" :key="item.id">
                      <a @click="onClickFormula(item.id)" >{{ item.formulation_code }}</a> ,
                    </span>
                  </vs-td>


                  <vs-td :data="data[indextr].assigned_staff">
                    <template v-if="Array.isArray(data[indextr].assigned_staff) && data[indextr].assigned_staff.length">
                      <span v-if="data[indextr].assigned_staff.length === 1">{{ data[indextr].assigned_staff[0].name }}</span>
                      <vx-tooltip v-else :text="data[indextr].assigned_staff.map(s => s.name).join(', ')" position="top" style="display: inline-block">
                        <span>{{ data[indextr].assigned_staff.length }} staff members</span>
                      </vx-tooltip>
                    </template>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip transparent :color="projectBriefColorFactory(tr.status.id)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td v-can="'create-edit-project-brief'">
                    <div class="vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.native="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-project-brief-pop-up ref="createCustomerProjectBriefPopUp"/>
    <update-customer-project-brief-pop-up ref="updateCustomerProjectBriefPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import CreateCustomerProjectBriefPopUp from '@/components/popups/customer/project-brief/CreateCustomerProjectBriefPopUp'
  import UpdateCustomerProjectBriefPopUp from '@/components/popups/customer/project-brief/UpdateCustomerProjectBriefPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: 'CustomerProjectBriefList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: ''
      }
    },
    components: {
      'v-select': vSelect,
      CreateCustomerProjectBriefPopUp,
      UpdateCustomerProjectBriefPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
    },
    methods: {
      async refreshData () {
        this.loadStaff()
      },

      async loadStaff() {
        await this.$vs.loading({
          container: '#customer-project-brief-list-table',
          scale: 0.45
        })
        const {data} = await CustomerRepository.getCustomerProjectBrief(this.customerId, this.page, this.filterQuery, 10, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close('#customer-project-brief-list-table > .con-vs-loading')
      },

      async onClickCreateSite () {
        await this.$refs.createCustomerProjectBriefPopUp.openPopup(this.customerId)
      },
      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerProjectBriefPopUp.openPopup(id)
      },

      filterQueryUpdate (){
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return 'danger';
        }
      },
      onClickFormula(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      },
    },
    watch : {
      page(){
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
